
import { Reti } from '../Wallets';
import { getChainParameters } from './getChainParameters';

export function isChainCorrect(_chainId, rete = Reti.ETHEREUM) {
    const dataChain = getChainParameters(rete);
    const chainIdCorrect = dataChain.chainId;
    return chainIdCorrect == _chainId;
}